import React from 'react';
import { Link } from 'shared';

import { HeaderNavWrapper } from './HeaderNav.styles';
import { HeaderNavProps } from './HeaderNav.types';

export const HeaderNav = ({ active, links, onClickLink }: HeaderNavProps) => (
  <HeaderNavWrapper className="header__nav">
    <ul className="header__nav-list">
      {links.map((link, index) => (
        <li className="header__nav-item" key={index}>
          <Link
            className={`header__nav-link ${active === link.url ? 'header__nav-link--active' : ''}`}
            onClick={onClickLink}
            {...link}
          />
        </li>
      ))}
    </ul>
  </HeaderNavWrapper>
);
